/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_hint_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter an error probability between 0 and 1 to get the Q score.`)
};

const es_phred_hint_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce una probabilidad de error entre 0 y 1 para obtener la puntuación Q.`)
};

const de_phred_hint_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine Fehlerwahrscheinlichkeit zwischen 0 und 1 ein, um den Q-Wert zu erhalten.`)
};

const nl_phred_hint_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul een foutkans tussen 0 en 1 in om de Q-score te krijgen.`)
};

const fr_phred_hint_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez une probabilité d'erreur entre 0 et 1 pour obtenir le score Q.`)
};

const it_phred_hint_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci una probabilità di errore tra 0 e 1 per ottenere il punteggio Q.`)
};

const pt_br2_phred_hint_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe uma probabilidade de erro entre 0 e 1 para obter o escore Q.`)
};

const pt_phred_hint_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza uma probabilidade de erro entre 0 e 1 para obter a pontuação Q.`)
};

const ja_phred_hint_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0から1の間のエラー確率を入力するとQスコアが得られます。`)
};

const zh_phred_hint_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入 0 到 1 之间的错误概率以获得 Q 分数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_hint_p = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_hint_p(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_hint_p", locale)
	if (locale === "en") return en_phred_hint_p(inputs)
	if (locale === "es") return es_phred_hint_p(inputs)
	if (locale === "de") return de_phred_hint_p(inputs)
	if (locale === "nl") return nl_phred_hint_p(inputs)
	if (locale === "fr") return fr_phred_hint_p(inputs)
	if (locale === "it") return it_phred_hint_p(inputs)
	if (locale === "pt-BR") return pt_br2_phred_hint_p(inputs)
	if (locale === "pt") return pt_phred_hint_p(inputs)
	if (locale === "ja") return ja_phred_hint_p(inputs)
	return zh_phred_hint_p(inputs)
};